module.exports = __webpack_public_path__ + "static/img/carousel2.1e60d5f2.jpg";